(() => {
  const preview = document.querySelector('.print-preview');

  if (!preview) {
    return;
  }

  const section = preview.closest('.shopify-section');
  const block = section?.querySelector('[data-forms-id]');

  if (!block) {
    return;
  }

  let checkIntervalStart = new Date;
  let checkInterval = setInterval(() => {
    const elapsed = (new Date - checkIntervalStart) / 1000;

    // Stop watching after 10 seconds of waiting
    if (elapsed > 10) {
      clearInterval(checkInterval);
      return;
    }

    const component = section.querySelector('shopify-forms-embed');
    const shadowRoot = component?.shadowRoot;

    if (!shadowRoot) {
      return;
    }

    const select = shadowRoot.querySelector('[aria-controls="custom#wybierz_rodzaj_produktu_do_personalizacji-selector-dropdown"]');

    if (!select) {
      return;
    }

    const observer = new MutationObserver(() => {
      const value = select.querySelector('[class^="_selectToggleText"]')?.textContent;

      updatePreview(value);
    });

    observer.observe(select, {
      childList: true,
      subtree: true,
      characterData: true
    });

    clearInterval(checkInterval);
  }, 25);

  const updatePreview = (value) => {
    if (!value) {
      preview.classList.remove('print-preview--showing');
      preview.querySelectorAll('.print-preview__image').forEach(image => image.classList.remove('show'));
    } else {
      let found = false;
      let lowerValue = value.trim().toLowerCase();

      preview.querySelectorAll('.print-preview__image').forEach(image => {
        const imgValue = image.dataset.value?.trim().toLowerCase();

        if (imgValue && imgValue === lowerValue) {
          image.classList.add('show');
          found = true;
        } else {
          image.classList.remove('show')
        }
      });

      if (found) {
        preview.classList.add('print-preview--showing');
      } else {
        preview.classList.remove('print-preview--showing');
      }
    }
  }
})();